/* Small progressive enhancement; Impact owns commerce and navigation. */
const acHydrateDeferredVideo = video => {
 if(video.dataset.acVideoHydrated==='true')return;
 let changed=false;
 video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;source.removeAttribute('data-src');changed=true;});
 if(video.dataset.src){video.src=video.dataset.src;video.removeAttribute('data-src');changed=true;}
 video.dataset.acVideoHydrated='true';
 video.preload='metadata';
 const reveal=()=>{video.dataset.acVideoReady='true';};
 if(video.readyState>=2)reveal();else video.addEventListener('loadeddata',reveal,{once:true});
 if(changed)video.load();
};

const acPlayDeferredVideo = video => {
 acHydrateDeferredVideo(video);
 const playback=video.play();
 if(playback)playback.catch(()=>{});
};

if (!customElements.get('ac-training-tabs')) customElements.define('ac-training-tabs', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return; this.ready=true;
  this.tabs=[...this.querySelectorAll('[role="tab"]')];
  this.panels=[...this.querySelectorAll('[role="tabpanel"]')];
  this.orientationQuery=window.matchMedia('(max-width:699px)');
  this.orientationHandler=()=>this.querySelector('[role="tablist"]')?.setAttribute('aria-orientation',this.orientationQuery.matches?'horizontal':'vertical');
  this.orientationHandler();this.orientationQuery.addEventListener('change',this.orientationHandler);
  this.clickHandler=e=>{const tab=e.target.closest('[role="tab"]');if(tab&&this.contains(tab))this.select(this.tabs.indexOf(tab),false);};
  this.keyHandler=e=>{const i=this.tabs.indexOf(e.target);if(i<0)return;let n=i;if(['ArrowRight','ArrowDown'].includes(e.key))n=(i+1)%this.tabs.length;else if(['ArrowLeft','ArrowUp'].includes(e.key))n=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();this.select(n,true);};
  this.addEventListener('click',this.clickHandler);this.addEventListener('keydown',this.keyHandler);
  this.nearViewport=!('IntersectionObserver' in window);
  if('IntersectionObserver' in window){this.videoObserver=new IntersectionObserver(entries=>{this.nearViewport=entries.some(entry=>entry.isIntersecting);this.syncVideos();},{rootMargin:'320px 0px',threshold:.01});this.videoObserver.observe(this);}
  this.select(Math.max(0,this.tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true')),false);
 }
 select(index,focus){this.tabs.forEach((tab,i)=>{const active=i===index;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;this.panels[i].hidden=!active;});this.syncVideos();if(focus)this.tabs[index].focus();}
 syncVideos(){this.panels.forEach(panel=>panel.querySelectorAll('video').forEach(video=>{video.controls=false;video.muted=true;video.loop=true;if(!panel.hidden&&this.nearViewport)acPlayDeferredVideo(video);else video.pause();}));}
 disconnectedCallback(){this.videoObserver?.disconnect();this.orientationQuery?.removeEventListener('change',this.orientationHandler);this.removeEventListener('click',this.clickHandler);this.removeEventListener('keydown',this.keyHandler);this.ready=false;}
 });

(() => {
 const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target;if(entry.isIntersecting)acPlayDeferredVideo(video);else video.pause();}),{rootMargin:'320px 0px',threshold:.01}):null;
 const observe=root=>root.querySelectorAll?.('video[data-ac-deferred-autoplay]').forEach(video=>{if(video.dataset.acDeferredObserved)return;video.dataset.acDeferredObserved='true';if(observer)observer.observe(video);else acPlayDeferredVideo(video);});
 observe(document);
 document.addEventListener('shopify:section:load',event=>observe(event.target));
})();

(() => {
 let switcher;
 function placeLanguage(){
  const slot=document.getElementById('ac-language-switcher-slot');
  switcher=document.getElementById('transcySwitcherContainer')||switcher;
  if(!slot||!switcher)return false;
  if(switcher.parentElement!==slot)slot.appendChild(switcher);
  slot.hidden=false;return true;
 }
 if(!placeLanguage()){
  const observer=new MutationObserver(()=>{if(placeLanguage())observer.disconnect();});
  observer.observe(document.body,{childList:true,subtree:true});
  setTimeout(()=>observer.disconnect(),30000);
 }
 document.addEventListener('shopify:section:load',placeLanguage);
})();

/* Keep closed support and offer launchers above Impact's product purchase bar. */
(() => {
 const barSelector = 'product-quick-add';
 const supportSelector = '.BeaconFabButtonFrame, .BeaconContainer';
 const bars = new Set();
 let frame = 0;
 let refresh = true;
 const sizes = new ResizeObserver(() => schedule());

 function schedule(rescan = false) {
  refresh = refresh || rescan;
  if (!frame) frame = requestAnimationFrame(update);
 }

 function update() {
  frame = 0;
  const body = document.body;
  // Restore purchase controls before measuring when the native support window closes.
  const supportOpen = !!document.querySelector('.BeaconFabButtonFrame iframe[title="Help Scout Beacon - Close"]')
   || Array.from(document.querySelectorAll('.BeaconContainer')).some(panel => {
    const style = getComputedStyle(panel);
    return !panel.hidden && panel.getAttribute('aria-hidden') !== 'true'
     && style.display !== 'none' && style.visibility !== 'hidden' && panel.getClientRects().length > 0;
   });
  body.toggleAttribute('data-ac-support-open', supportOpen);
  if (refresh) {
   const current = new Set(document.querySelectorAll(barSelector));
   bars.forEach(bar => { if (!current.has(bar)) { sizes.unobserve(bar); bars.delete(bar); } });
   current.forEach(bar => { if (!bars.has(bar)) { bars.add(bar); sizes.observe(bar); } });
   refresh = false;
  }
  let clearance = 0;
  bars.forEach(bar => {
   if (!bar.isConnected || bar.hidden || !bar.classList.contains('is-visible')) return;
   const style = getComputedStyle(bar);
   if (style.display === 'none' || supportOpen) return;
   // Height + fixed bottom stays correct during the native entrance animation.
   clearance = Math.max(clearance, bar.getBoundingClientRect().height + (parseFloat(style.bottom) || 0));
  });
  const value = clearance ? `${Math.ceil(clearance + 16)}px` : '';
  if (body.style.getPropertyValue('--ac-product-bar-clearance') !== value) {
   if (value) body.style.setProperty('--ac-product-bar-clearance', value);
   else body.style.removeProperty('--ac-product-bar-clearance');
  }
  body.toggleAttribute('data-ac-product-bar-visible', clearance > 0);

  let buyClearance = 0;
  if (matchMedia('(max-width:767px)').matches && !supportOpen) {
   const launcher = document.querySelector('.BeaconFabButtonFrame');
   const width = launcher?.getBoundingClientRect().width || 60;
   const bottom = Math.max(16, clearance ? clearance + 16 : 0);
   document.querySelectorAll('.shopify-section--main-product .product-info__buy-buttons').forEach(purchase => {
    const rect = purchase.getBoundingClientRect();
    if (rect.width && rect.height && rect.right > innerWidth - 16 - width
     && rect.bottom > innerHeight - bottom - width && rect.top < innerHeight - bottom) {
     buyClearance = Math.max(buyClearance, Math.ceil(innerHeight - rect.top + 16));
    }
   });
  }
  const buyValue = buyClearance ? `${buyClearance}px` : '';
  if (body.style.getPropertyValue('--ac-mobile-buy-clearance') !== buyValue) {
   if (buyValue) body.style.setProperty('--ac-mobile-buy-clearance', buyValue);
   else body.style.removeProperty('--ac-mobile-buy-clearance');
  }
 }

 const relevantNode = node => node.nodeType === 1
  && (node.matches(`${barSelector}, ${supportSelector}`) || node.querySelector(`${barSelector}, ${supportSelector}`));
 const changes = new MutationObserver(records => {
  if (records.some(record => record.type === 'attributes'
   ? record.target.matches(barSelector) || record.target.closest(supportSelector)
   : record.target.closest?.(supportSelector) || Array.from(record.addedNodes).some(relevantNode)
    || Array.from(record.removedNodes).some(relevantNode))) schedule(true);
 });
 changes.observe(document.body, {subtree: true, childList: true, attributes: true,
  attributeFilter: ['class', 'style', 'title', 'hidden', 'aria-hidden']});
 window.addEventListener('resize', () => schedule(), {passive: true});
 window.addEventListener('scroll', () => schedule(), {passive: true});
 window.visualViewport?.addEventListener('resize', () => schedule(), {passive: true});
 window.addEventListener('pageshow', () => schedule(true));
 document.addEventListener('shopify:section:load', () => schedule(true));
 document.addEventListener('shopify:section:unload', () => schedule(true));
 schedule(true);
})();
